var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "login", attrs: { fluid: "" } },
    [
      _c("div", { staticClass: "py-5 app-title font-bold" }, [
        _c("img", {
          attrs: {
            src: require("../../static/img/doe-logo.png"),
            alt: "Hawaii DOE Logo"
          }
        }),
        _vm._v(" "),
        _c("div", [_vm._v("OT Service Logs")])
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticClass: "mt-5 pb-5",
          attrs: { row: "", wrap: "", "align-center": "", "justify-center": "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c("div", { staticClass: "login-text" }, [_vm._v("Log in")])
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs10: "", sm7: "", md6: "", lg5: "", xl4: "" } },
            [
              _c(
                "v-form",
                { staticClass: "mt-5" },
                [
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "Enter your username",
                      name: "login",
                      label: "Username",
                      color: "secondary",
                      "error-messages": _vm.usernameErrors,
                      autocomplete: "off",
                      type: "text"
                    },
                    on: {
                      blur: _vm.$v.username.$touch,
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onLoginClick($event)
                      }
                    },
                    model: {
                      value: _vm.username,
                      callback: function($$v) {
                        _vm.username =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "username"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "Enter your password",
                      name: "password",
                      label: "Password",
                      color: "secondary",
                      "error-messages": _vm.passwordErrors,
                      autocomplete: "off",
                      type: "password"
                    },
                    on: {
                      blur: _vm.$v.password.$touch,
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onLoginClick($event)
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "password"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    { attrs: { value: _vm.errorMsg, type: "error" } },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.errorMsg) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "font-bold mt-5",
                      attrs: {
                        disabled: _vm.showLoading,
                        color: "secondary",
                        large: "",
                        round: "",
                        block: ""
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.onLoginClick($event)
                        }
                      }
                    },
                    [_vm._v("\n          Log in\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7589b93f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7589b93f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = null
// module chunks = 